import { useEffect } from 'react';
import { useDeepCompareMemo } from 'use-deep-compare';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import useCreateRanchSummaryTableDateRange from '../../dataGridTables/ranchSummary/hooks/useCreateRanchSummaryTableDateRange';
import { setIsLoadingCustomerSummary } from '../../ranches/ranchesSlice';
import {
  selectCurrCustomerID,
  selectCurrScanID,
} from '../../select/selectSlice';
import { useCustomerSummaryQuery } from './useCustomerSummaryQuery';
import { useIsRanchSummaryTable } from './useIsRanchSummaryTable';

export const useGetCustomerSummaryInfo = () => {
  const dispatch = useAppDispatch();
  const customerId = useAppSelector(selectCurrCustomerID);
  const currScanId = useAppSelector(selectCurrScanID);

  const { daysSinceNow } = useCreateRanchSummaryTableDateRange();

  // If ranch summary table is selected, fetch by customer and date range to limit the amount of data.  Otherwise, fetch by scan ID for a specific scan on block detail.
  // This is a temporary solution until we switch to dremio.
  const isRanchSummaryTable = useIsRanchSummaryTable();

  const cubeResults = useCustomerSummaryQuery(
    isRanchSummaryTable ? !customerId : !currScanId,
    isRanchSummaryTable ? undefined : currScanId,
    undefined,
    false,
    isRanchSummaryTable ? customerId : undefined,
    undefined,
    isRanchSummaryTable ? daysSinceNow : undefined
  );

  // Update loading state
  useEffect(() => {
    if (cubeResults) {
      dispatch(setIsLoadingCustomerSummary(cubeResults.isLoading));
    }
  }, [cubeResults.isLoading, dispatch]);

  const customerSummary = useDeepCompareMemo(() => {
    if (
      (isRanchSummaryTable && customerId === '') ||
      (!isRanchSummaryTable && currScanId === '')
    )
      return null;
    return cubeResults;
  }, [cubeResults, currScanId, isRanchSummaryTable]);

  return customerSummary;
};
